export default __webpack_public_path__ + "static/media/bannerPurple.a42b5c05.png";